import {
  parseDeploymentConfig,
  setDeploymentConfig,
  type DeploymentConfig,
} from "../config/storefrontRouting";

const REQUEST_TIMEOUT_MS = 10_000;

function normalizeBaseUrl(url: string): string {
  const normalized = url.endsWith("/") ? url : `${url}/`;
  return new URL(normalized, window.location.origin).toString();
}

async function apiBaseUrl(): Promise<string> {
  if (window.electronAPI?.isElectron && window.electronAPI.getBackendUrl) {
    const url = await window.electronAPI.getBackendUrl();
    if (!url) throw new Error("Electron backend URL is unavailable");
    return normalizeBaseUrl(url);
  }
  const env = import.meta.env as { VITE_API_BASE_URL?: string };
  return normalizeBaseUrl(
    env.VITE_API_BASE_URL || "http://localhost:4000/api/",
  );
}

export async function loadDeploymentConfig(): Promise<DeploymentConfig> {
  const controller = new AbortController();
  const timeout = window.setTimeout(
    () => controller.abort(),
    REQUEST_TIMEOUT_MS,
  );
  try {
    const response = await fetch(
      new URL("deployment/config", await apiBaseUrl()),
      {
        headers: { Accept: "application/json" },
        signal: controller.signal,
      },
    );
    if (!response.ok) {
      throw new Error(`Deployment configuration request failed (${response.status})`);
    }
    const config = parseDeploymentConfig(await response.json());
    setDeploymentConfig(config);
    return config;
  } finally {
    window.clearTimeout(timeout);
  }
}
